import React from "react";
import Card from "./Card"; 
import { unlockCard } from "../pages/HostGame";

export default function Draft({ socket, roomCode, gamePhase, playersReady, myPlayer, myPlayerIndex, players }) {
  if (gamePhase !== "start_draft") return null;

  const amIReady = playersReady.includes(myPlayer.id);

  if (!myPlayer || !myPlayer.draftOptions) {
    return <div style={{color: "white", textAlign: "center", marginTop: 50}}>Lade Draft... 🔮</div>;
  }

  return (
    <div style={{ 
      padding: "40px 20px", color: "white", minHeight: "100vh", fontFamily: "sans-serif",
      backgroundImage: "url('/background.png')", backgroundSize: "cover", backgroundPosition: "center", backgroundAttachment: "fixed",
      display: "flex", flexDirection: "column", alignItems: "center"
    }}>
      
      {/* GLOBAL HOVER EFFECTS */}
      <style>{`
        button { transition: transform 0.1s ease-in-out, filter 0.1s ease-in-out, box-shadow 0.1s ease-in-out; }
        button:not(:disabled):hover { transform: scale(1.05); filter: brightness(1.2); }
        button:disabled { opacity: 0.5; cursor: not-allowed !important; transform: none !important; filter: none !important; }
      `}</style>

      {/* HEADER */}
      <div style={{ textAlign: "center", marginBottom: 40, width: "100%" }}>
        <h1 style={{ fontSize: "3.5em", margin: "0 0 10px 0", textShadow: "0 4px 10px rgba(0,0,0,0.8)" }}>
          First Draft
        </h1>
        <p style={{ color: "#aaa", fontSize: "1.2em", margin: 0, fontWeight: "bold" }}>
          Choose an Effect to start with this Game.
        </p>
      </div>

      {/* DRAFT KARTEN CONTAINER (Glass-Morphism) */}
      <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
        
        <div style={{ 
          backgroundColor: "rgba(30, 30, 30, 0.7)", border: "4px solid gold", borderRadius: 20, 
          padding: "40px", width: "100%", maxWidth: "900px", display: "flex", flexDirection: "column", 
          alignItems: "center", backdropFilter: "blur(10px)", marginBottom: "30px", boxShadow: "0 10px 30px rgba(0,0,0,0.5)"
        }}>
          
          <div style={{ display: "flex", gap: 30, justifyContent: "center", flexWrap: "wrap" }}>
            {myPlayer.draftOptions.map((effect, index) => {
              // --- NEU: SICHERHEITSCHECK ---
              // Falls das Backend versehentlich 'null' statt einer echten Karte gesendet hat,
              // überspringen wir dieses Element und der Browser stürzt nicht ab!
              if (!effect) return null;

              return (
                <div 
                  key={effect.id || index} 
                  style={{ width: "160px", textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center", opacity: amIReady ? 0.5 : 1 }}
                >
                  <Card 
                    card={effect} 
                    disabled={amIReady}
                    onClick={() => {
                      // NEU: Effekt für die Sammlung freischalten!
                      if (effect.name) unlockCard(effect);
                      
                      // Server informieren
                      socket.emit("draft_ready", { roomCode, playerIndex: myPlayerIndex, effect });
                    }} 
                  />
                  
                  <div style={{ 
                    marginTop: "15px", backgroundColor: "rgba(20, 20, 20, 0.8)", padding: "15px 10px", 
                    borderRadius: "10px", border: "2px solid #444", width: "100%", minHeight: "90px", 
                    display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "center" 
                  }}>
                    <b style={{ color: "gold", display: "block", marginBottom: "8px", textTransform: 'capitalize', fontSize: "1.1em" }}>
                      {effect.name || "Unknown"}
                    </b>
                    <span style={{ fontSize: "0.8em", color: "#888", display: "block", lineHeight: "1.3" }}>
                      {effect.description || "No description available"}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* READY STATUS */}
        <div>
          {amIReady ? (
            <button disabled={true} style={{ padding: "15px 50px", fontSize: "1.5em", backgroundColor: "rgba(17,17,17,0.9)", color: "green", fontWeight: "bold", border: "2px solid green", borderRadius: 15, backdropFilter: "blur(5px)" }}>
              Waiting {playersReady.length}/{players.length}...
            </button>
          ) : (
            <div style={{ padding: "15px 50px", fontSize: "1.5em", backgroundColor: "rgba(51,51,51,0.8)", color: "white", fontWeight: "bold", border: "2px solid #555", borderRadius: 15, backdropFilter: "blur(5px)" }}>
              Click a Card!
            </div>
          )}
        </div>

      </div>
    </div>
  );
}